module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "svga-box"
  }, [_c('div', {
    ref: "drawContainer",
    staticClass: "drawBtn"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-075dbba1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/playSvga/playSvga.vue
// module id = 797
// module chunks = 1